import type { InputMenuItem } from '@nuxt/ui'
import type { Destination } from '../geo/Destination'

/** Adapta un `Destination` al modelo que espera `UInputMenu` (`InputMenuItem`). */
export function destinationToInputMenuItem(
  d: Destination | null | undefined,
): InputMenuItem | undefined {
  if (d == null) return undefined
  return d as unknown as InputMenuItem
}
